import React from 'react';

import { Alert } from '@clearcover/atlas';

type VehicleSetupType = {
  setupDueDate: string;
};

export const VehicleSetup = ({ setupDueDate }: VehicleSetupType) => {
  return (
    <div data-testid="vehicle-setup">
      <h4>Vehicle setup required</h4>
      <p>
        This policy requires the customer download our mobile app and complete
        vehicle setup in order to secure coverage. They will need to use the
        Clearcover app and follow our step-by-step instructions to record and
        submit video of their vehicle(s) in a well-lit area.{' '}
        <a
          rel="noreferrer"
          target="_blank"
          href="https://resources.clearcover.com/hc/en-us"
        >
          Learn More
        </a>
      </p>
      <Alert
        type="warning-default"
        message={`Important: Vehicle setup is required by ${setupDueDate} to prevent coverage interruption and/or premium changes.`}
      />
    </div>
  );
};
